/* ==========================================================================
   OZARIA Frame — front-end logic
   Gallery · quantity · bundle tiers · delivery estimate · Christmas banner ·
   FAQ · sticky buy bar · welcome-code pop-up · cart enhancements.
   Vanilla JS, no dependencies. Safe to run on every page.
   ========================================================================== */
(function () {
  'use strict';

  /* The script is loaded once from theme.liquid. If a section ever pulls it in
     again, a second copy would build a second pop-up and double every listener. */
  if (window.__ozfLoaded) return;
  window.__ozfLoaded = true;

  var PRODUCT_PATH = '/products/dog-back-seat-extender';
  var CODE = 'FRAME15';
  var UNIT_CENTS = 22900;
  var KLAVIYO_COMPANY = 'XrkCe5';

  /* ---------- helpers ---------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- delivery estimate: 4-9 business days ---------- */
  function addBusinessDays(n) {
    var d = new Date();
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function etaText() {
    return fmtDate(addBusinessDays(4)) + ' – ' + fmtDate(addBusinessDays(9));
  }
  var TRUCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>';

  /* The seasonal message. Must stay in step with snippets/oz-season.liquid,
     which picks the same line server side. This pass only re-asserts it, so a
     page served from cache can never show last month's message. */
  function seasonMode() {
    var now = new Date();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    if (m === 10 || m === 11 || (m === 12 && d <= 1)) return 'cutoff';
    if (m === 12 && d <= 24) return 'closed';
    return 'none';
  }
  function initSeason() {
    var want = seasonMode();
    qa('.ozf-seas').forEach(function (slot) {
      qa('[data-ozf-season]', slot).forEach(function (n) {
        n.classList.toggle('is-on', n.getAttribute('data-ozf-season') === want);
      });
    });
  }

  /* OZ-PROMO-1005: limited-time offer, 1 frame at $199 until Thu Oct 8, 11:59 PM PT.
     The price cut itself is the automatic Shopify discount with the same end date.
     Server side, oz-frame-pdp.liquid renders the offer only inside its window; here
     we run the countdown, and if a cached page is still showing the offer after the
     end, we put the normal price back so nobody sees a deadline that has passed. */
  var PROMO_END = Date.parse('2026-10-09T06:59:59Z');
  function promoLeft() {
    var ms = PROMO_END - Date.now();
    if (ms <= 0) return '';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    return (d ? d + 'd ' : '') + p2(h) + 'h ' + p2(m) + 'm ' + p2(sec) + 's';
  }
  function endPromo() {
    qa('[data-ozf-promo]').forEach(function (n) { n.remove(); });
    var full = UNIT_CENTS;
    /* OZ-BOOST-1006: the receipt under the packs shows the price too. */
    qa('[data-ozf-rcpt-price]').forEach(function (n) { n.textContent = money(full).replace(/\.00$/, ''); });
    var pr = q('[data-ozf-promo-price]');
    if (pr) {
      var was = q('.ozf-pdp__was', pr); if (was) was.remove();
      var b = q('b', pr); if (b) b.textContent = money(full).replace(/\.00$/, '');
      var pay4 = pr.nextElementSibling;
      var b4 = pay4 && pay4.classList.contains('ozf-pdp__pay4') && q('b', pay4);
      if (b4) b4.textContent = money(full / 4);
    }
    qa('[data-ozf-full]').forEach(function (row) {
      row.classList.remove('is-promo');
      var w = q('.ozf-bundle__was', row); if (w) w.remove();
      var now = q('.ozf-bundle__now', row); if (now) now.textContent = row.getAttribute('data-ozf-full');
      var sub = q('.ozf-bundle__s', row); if (sub) sub.textContent = row.getAttribute('data-ozf-full-sub') || '';
      row.removeAttribute('data-ozf-full');
    });
    /* The sticky bar copies the active row: refresh it from the restored row. */
    var row = q('[data-ozf-tier].is-active') || q('[data-ozf-tier]');
    var sp = q('.ozf-sticky__p'), sn = row && q('.ozf-bundle__now', row), sw = q('.ozf-sticky__was');
    if (sp && sn) sp.textContent = sn.textContent.trim().replace(/\.00$/, '');
    if (sw && row && !q('.ozf-bundle__was', row)) sw.hidden = true;
    document.dispatchEvent(new Event('ozf:promo-end'));
  }
  function initPromo() {
    var box = q('[data-ozf-promo]');
    var onCart = /^\/cart\/?$/.test(location.pathname);
    if (!box && !onCart) return;
    if (!promoLeft()) { if (box) endPromo(); return; }
    function tick() {
      var t = promoLeft();
      if (!t) { endPromo(); qa('.ozf-cart-promo').forEach(function (n) { n.remove(); }); clearInterval(timer); return; }
      qa('[data-ozf-promo-left]').forEach(function (n) { n.textContent = t; });
      /* Cart: the line under the total, only when Shopify applied the offer. */
      if (onCart && !q('.ozf-cart-promo') && /Fall offer/.test(document.body.innerText)) {
        var host = q('.cart-totals__container') || q('.cart-totals');
        if (host) host.appendChild(el('p', 'ozf-cart-promo', 'Fall offer: $199 &mdash; ends in <b data-ozf-promo-left>' + t + '</b>'));
      }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ==========================================================================
     Product page
     ========================================================================== */
  function initGallery() {
    qa('[data-ozf-gallery]').forEach(function (gal) {
      if (gal.getAttribute('data-ozf-bound')) return;
      var slides = q('[data-ozf-slides]', gal);
      if (!slides || !slides.children.length) return;
      gal.setAttribute('data-ozf-bound', '1');
      var thumbs = qa('[data-ozf-thumb]', gal);
      var count = q('[data-ozf-count]', gal);
      var total = slides.children.length;
      var target = 0;

      /* Gallery videos: native controls on phones only, and make sure the
         muted autoplay actually starts (some browsers ignore the attribute). */
      qa('video.ozf-gal-video', gal).forEach(function (vid) {
        vid.muted = true;
        vid.setAttribute('playsinline', '');
        function syncControls() {
          if (window.matchMedia('(max-width: 767px)').matches) vid.setAttribute('controls', '');
          else vid.removeAttribute('controls');
        }
        syncControls();
        window.addEventListener('resize', syncControls);
      });

      function paint(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + total;
        /* Make sure the video on screen is playing (muted, looped). */
        var cur = slides.children[i];
        var vid = cur && cur.querySelector('video.ozf-gal-video');
        if (vid && vid.paused) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
      }
      function goTo(i) {
        target = Math.max(0, Math.min(total - 1, i));
        paint(target);
        slides.scrollTo({ left: target * slides.clientWidth, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { goTo(i); });
      });
      qa('[data-ozf-nav]', gal).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ozf-nav') === 'next' ? 1 : -1;
          var i = target + dir;
          if (i < 0) i = total - 1;
          if (i > total - 1) i = 0;
          goTo(i);
        });
      });
      var raf;
      slides.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = slides.clientWidth || 1;
          target = Math.max(0, Math.min(total - 1, Math.round(slides.scrollLeft / w)));
          paint(target);
        });
      }, { passive: true });
      paint(0);
      /* Browsers pause muted videos in a background tab; resume on return. */
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) paint(target);
      });
    });
  }

  function initBuyBox() {
    var buy = q('[data-ozf-buy]');
    if (!buy) return;
    if (buy.getAttribute('data-ozf-bound')) return;
    buy.setAttribute('data-ozf-bound', '1');

    var input = q('[data-ozf-qty-input]', buy);
    var rows = qa('[data-ozf-tier]', buy);

    function syncTiers() {
      var val = parseInt(input && input.value, 10) || 1;
      rows.forEach(function (r) {
        r.classList.toggle('is-active', parseInt(r.getAttribute('data-ozf-tier'), 10) === val);
      });
    }
    function setQty(v) {
      if (!input) return;
      var val = Math.max(1, Math.min(10, v));
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncTiers();
    }

    qa('[data-ozf-qty-minus]', buy).forEach(function (b) {
      b.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) - 1); });
    });
    qa('[data-ozf-qty-plus]', buy).forEach(function (b) {
      b.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) + 1); });
    });
    if (input) input.addEventListener('change', syncTiers);
    /* OZ-TAP-1004: one tap on a pack adds it and opens the cart (owner's call: the
       "GET MY OZARIA FRAME" button is gone). The form submit handler below empties
       the cart first, so the cart always holds exactly the pack tapped. */
    var bundle = q('.ozf-bundle', buy);
    var soldOut = bundle && bundle.hasAttribute('data-ozf-soldout');
    /* OZ-V2-1006: a tap on a pack only selects it; the "Add to cart" button under the packs adds it. */
    rows.forEach(function (r) {
      r.setAttribute('role', 'radio');
      r.addEventListener('click', function () {
        setQty(parseInt(r.getAttribute('data-ozf-tier'), 10) || 1);
        rows.forEach(function (x) { x.setAttribute('aria-checked', x === r ? 'true' : 'false'); });
      });
    });
    /* Back from the cart (page restored from the back-forward cache): packs tappable again. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      buy.classList.remove('is-adding');
      rows.forEach(function (r) { r.classList.remove('is-busy'); });
    });
    syncTiers();

    /* The welcome offer lifts in when it reaches the screen, so the effect is
       seen rather than played out of sight while the visitor is at the top. */
    var offerBox = q('.ozf-offer', buy);
    if (offerBox && !offerBox.classList.contains('is-in')) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { offerBox.classList.add('is-in'); io.disconnect(); }
        }, { threshold: 0.35 });
        io.observe(offerBox);
        setTimeout(function () { offerBox.classList.add('is-in'); }, 8000);
      } else {
        offerBox.classList.add('is-in');
      }
    }

    /* Delivery estimate */
    var eta = q('[data-ozf-eta]', buy);
    /* OZ-BENCH-1002 (7)+(5): the delivery line speaks to the buyer ("at her door" for a
       gift), with a compact date range ("Oct 8–15"). */
    function etaShort() {
      var a = fmtDate(addBusinessDays(4)), b = fmtDate(addBusinessDays(9));
      var ma = a.split(' ')[0], mb = b.split(' ')[0];
      return ma === mb ? a + '\u2013' + b.split(' ').slice(1).join(' ') : a + ' \u2013 ' + b;
    }
    function renderEta() {
      if (!eta) return;
      var who = buy.getAttribute('data-ozf-for');
      var lead = who === 'gift' ? 'Order today \u2014 at their door ' : who === 'me' ? 'Order today \u2014 at your door ' : 'Free delivery \u2014 arrives ';
      eta.innerHTML = TRUCK_SVG + '<span>' + lead + '<b>' + etaShort() + '</b></span>';
    }
    renderEta();

    /* OZ-BENCH-1002 (5): gift / for me. */
    var giftOpts = qa('[data-ozf-gift]', buy);
    var giftTip = q('[data-ozf-gift-tip]', buy);
    var giftInput = q('[data-ozf-gift-input]', buy);
    giftOpts.forEach(function (o) {
      o.addEventListener('click', function () {
        var who = o.getAttribute('data-ozf-gift');
        buy.setAttribute('data-ozf-for', who);
        giftOpts.forEach(function (x) {
          var on = x === o;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (giftInput) giftInput.disabled = who !== 'gift';
        if (giftTip) {
          var t = buy.getAttribute(who === 'gift' ? 'data-ozf-gift-tip-gift' : 'data-ozf-gift-tip-me') || '';
          giftTip.textContent = t;
          giftTip.hidden = !t;
        }
        renderEta();
      });
    });

    /* The sticky bar follows the tier the customer picked. */
    function syncSticky() {
      var row = q('[data-ozf-tier].is-active', buy) || rows[0];
      if (!row) return;
      var n = q('.ozf-sticky__n');
      var p = q('.ozf-sticky__p');
      var label = q('.ozf-bundle__n', row);
      var price = q('.ozf-bundle__now', row);
      if (n && label) n.textContent = label.textContent.trim();
      if (p && price) p.textContent = price.textContent.trim().replace(/\.00$/, '');
      /* OZ-STICKY-1002: struck total for the multi-frame packs (same figure as the tier row). */
      var was = q('.ozf-sticky__was');
      var wasSrc = q('.ozf-bundle__was', row);
      if (was) { was.textContent = wasSrc ? wasSrc.textContent.trim().replace(/\.00$/, '') : ''; was.hidden = !wasSrc; }
      /* OZ-TIER-1002: the buttons say what they will add. */
      var qn = parseInt(row.getAttribute('data-ozf-tier'), 10) || 1;
      /* OZ-V2-1006: "Add to cart — $X" follows the chosen pack. */
      var atcPrice = q('[data-ozf-atc-price]', buy);
      if (atcPrice && price) atcPrice.textContent = price.textContent.trim().replace(/\.00$/, '');
      var stBar = q('[data-ozf-sticky]'); if (stBar) stBar.classList.toggle('is-multi', qn > 1);
    }
    (function () {
      var a1 = q('[data-ozf-atc]', buy); if (a1) a1.setAttribute('data-ozf-label', a1.textContent.trim());
      var s1 = q('[data-ozf-sticky-add] span'); if (s1) s1.setAttribute('data-ozf-label', s1.textContent.trim());
    })();
    rows.forEach(function (r) { r.addEventListener('click', function () { setTimeout(syncSticky, 0); }); });
    if (input) input.addEventListener('change', function () { setTimeout(syncSticky, 0); });
    syncSticky();
    document.addEventListener('ozf:promo-end', syncSticky);
    /* OZ-PACK-1002: an ad can open the page on a pack (?pack=2 for the "One for Mom,
       one for Grandma" ad), only when that tier exists on the page. */
    var pack = parseInt((location.search.match(/[?&]pack=(\d+)/) || [])[1], 10);
    if (pack > 1 && rows.some(function (r) { return parseInt(r.getAttribute('data-ozf-tier'), 10) === pack; })) setQty(pack);
  }

  /* OZ-TAP-1004: submit the product form the way a submit button would, so the AJAX
     add-to-cart below (and the AddToCart pixels) run. */
  function submitPack() {
    var form = q('#ozf-product-form');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  }

  function initSticky() {
    var bar = q('[data-ozf-sticky]');
    /* OZ-TAP-1004: the bar appears once the packs have scrolled past. */
    var anchor = q('[data-ozf-atc]') || q('[data-ozf-buy] .ozf-bundle');
    if (!bar || !anchor) return;
    if (bar.getAttribute('data-ozf-bound')) return;
    bar.setAttribute('data-ozf-bound', '1');
    /* OZ-STICKY-1002: one tap adds the chosen pack and opens the cart, through the same
       AJAX add-to-cart (and pixels) as a tap on a pack. */
    var btn = q('[data-ozf-sticky-add]', bar);
    if (btn) {
      btn.addEventListener('click', function () {
        if (anchor.hasAttribute('data-ozf-soldout') || anchor.disabled) { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        btn.classList.add('is-loading');
        btn.disabled = true;
        submitPack();
        setTimeout(function () { btn.classList.remove('is-loading'); btn.disabled = false; }, 6000);
      });
    }
    /* Show it once the buy button has scrolled past, hide it again over the
       footer so it never sits on top of the links. Scroll-driven rather than
       IntersectionObserver-only: the observer does not fire in every context. */
    var footer = q('.shopify-section-group-footer-group') || q('footer');
    function sync() {
      var a = anchor.getBoundingClientRect();
      var past = a.bottom < 0;
      var footerUp = false;
      if (footer) {
        var f = footer.getBoundingClientRect();
        footerUp = f.top < window.innerHeight - 8;
      }
      bar.classList.toggle('is-on', past && !footerUp);
    }
    /* Scroll events are the fast path, but some in-app browsers and embedded
       views never deliver them to the document, which left the bar hidden for
       the whole page. Two rect reads on a timer cost nothing and always fire,
       so the bar can no longer depend on an event that may never arrive. */
    document.addEventListener('scroll', sync, { passive: true, capture: true });
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(sync, { threshold: 0 }).observe(anchor);
    }

    var timer = null;
    function startPolling() { if (!timer) timer = setInterval(sync, 300); }
    function stopPolling() { if (timer) { clearInterval(timer); timer = null; } }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopPolling();
      else { sync(); startPolling(); }
    });
    sync();
    startPolling();
  }

  /* ==========================================================================
     FAQ accordions (homepage, product page, FAQ page)
     ========================================================================== */
  function initFaq() {
    qa('[data-ozf-faq] .ozf-faq__q').forEach(function (btn) {
      if (btn.getAttribute('data-ozf-bound')) return;
      btn.setAttribute('data-ozf-bound', '1');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var item = btn.closest('.ozf-faq__item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ==========================================================================
     Welcome-code pop-up (FRAME15)
     ========================================================================== */

  /* ---------- welcome pop-up: where and when it may appear ----------
     Allowed: the homepage, /pages/* and /collections/*.
     Never on /products/*, /cart, /checkout, /account or anywhere else.
     Once per visitor per 30 days, and never when a discount is already on the cart. */
  var POP_KEY = 'ozf_pop_seen';
  function popSeen() {
    try {
      if (document.cookie.indexOf(POP_KEY + '=1') > -1) return true;
      var t = localStorage.getItem(POP_KEY);
      if (t && (Date.now() - parseInt(t, 10)) < 30 * 864e5) return true;
    } catch (e) {}
    return false;
  }
  function popMarkSeen() {
    try {
      document.cookie = POP_KEY + '=1; path=/; max-age=' + (30 * 86400) + '; SameSite=Lax';
      localStorage.setItem(POP_KEY, String(Date.now()));
    } catch (e) {}
  }
  function popPageAllowed(p) {
    if (p.indexOf('/cart') === 0) return false;
    if (p.indexOf('/checkout') === 0) return false;
    if (p.indexOf('/account') === 0) return false;
    if (p === '/' || p === '') return true;
    if (p.indexOf('/products/') === 0) return true;
    if (p.indexOf('/pages/') === 0) return true;
    if (p.indexOf('/collections/') === 0) return true;
    return false;
  }
  function cartHasDiscount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c) return false;
        if (c.cart_level_discount_applications && c.cart_level_discount_applications.length) return true;
        if (c.discount_applications && c.discount_applications.length) return true;
        var items = c.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].discounts && items[i].discounts.length) return true;
        }
        return false;
      })
      .catch(function () { return false; });
  }

  function initPopup() {
    /* OZ-BOOST-1006: no 15% pop-up while the $199 Fall offer runs (15% of $229 = $194.65
       would undercut it and blur the one message). It comes back by itself after the end. */
    if (promoLeft()) return;
    var p = location.pathname;
    if (!popPageAllowed(p)) { exposeReopen(); return; }

    /* Having already seen it only stops the AUTOMATIC opening. The "show me the
       offer" link is a deliberate action and must always reopen the real window. */
    var autoAllowed = !popSeen();

    var built = false;

    function build() {
      if (built) return;
      built = true;
      var ov = el('div', 'ozf');
      ov.id = 'ozf-pop-ov';
      ov.innerHTML =
        '<div id="ozf-pop" role="dialog" aria-modal="true" aria-label="15% welcome offer">' +
          '<button class="ozf-x" type="button" aria-label="Close">&times;</button>' +
          '<div class="ozf-form">' +
            '<p class="ozf-pop__ey">Welcome offer</p>' +
            '<h3>Send a photo they’ll never forget.</h3>' +
            '<p class="ozf-pop__sub">Enter your email for news and offers from OZARIA.</p>' +
            '<input type="email" placeholder="Your email" autocomplete="email" aria-label="Your email" />' +
            '<button class="ozf-btn ozf-btn--wide ozf-send" type="button">SEND MY 15% CODE</button>' +
            '<p class="ozf-pop__fine">Free US shipping &middot; 30-day refund &middot; No monthly fees, ever</p>' +
          '</div>' +
          '<div class="ozf-code">' +
            '<p class="ozf-pop__ey">You are in</p>' +
            '<h3>Here is your 15%.</h3>' +
            '<div class="ozf-codebox">' + CODE + '</div>' +
            '<button class="ozf-btn ozf-btn--wide ozf-apply" type="button">APPLY &amp; SEE THE FRAME</button>' +
            '<p class="ozf-pop__fine">One per customer. Applied automatically at checkout.</p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ov);

      var pop = q('#ozf-pop', ov);
      function done() { popMarkSeen(); }
      function close() { done(); ov.classList.remove('on'); }

      q('.ozf-x', ov).addEventListener('click', close);
      ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ov.classList.contains('on')) close();
      });

      q('.ozf-send', ov).addEventListener('click', function () {
        var inp = q('input[type=email]', ov);
        var email = (inp.value || '').trim();
        if (email.indexOf('@') < 1 || email.lastIndexOf('.') < email.indexOf('@')) {
          inp.focus();
          inp.style.borderColor = '#8C2F2F';
          return;
        }
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email, properties: { source: 'frame-welcome-popup' } } } }
              }
            }
          })
        }).catch(function () {});
        fetch('/discount/' + CODE).catch(function () {});
        done();
        pop.classList.add('done');
      });

      q('.ozf-apply', ov).addEventListener('click', function () {
        window.location.href = '/discount/' + CODE + '?redirect=' + encodeURIComponent(PRODUCT_PATH);
      });

      setTimeout(function () { ov.classList.add('on'); }, 250);
    }

    window.ozfOpenPop = function () {
      var ov = document.getElementById('ozf-pop-ov');
      if (ov) { ov.classList.add('on'); return; }
      built = false;
      build();
    };

    var fired = false;
    function go() { if (fired) return; fired = true; build(); }

    if (autoAllowed) {
      /* 1 s after arrival on the product page, where the offer is the whole point;
         15 s elsewhere. Counted from page load, not from when the cart check
         returns, so a slow network does not quietly stretch the wait. */
      /* OZ-QW-1002: 30 s on the product page (was 1 s, it covered the photo before the
         visitor had seen the frame), or earlier once they have scrolled 60% of the page. */
      var delay = p.indexOf('/products/') === 0 ? 30000 : 15000;
      /* A visitor who already has a discount on the cart is never shown the offer. */
      cartHasDiscount().then(function (has) {
        if (has) return;
        var elapsed = (window.performance && performance.now) ? performance.now() : 0;
        setTimeout(go, Math.max(0, delay - elapsed));
        document.addEventListener('mouseout', function (e) {
          if (e.clientY <= 0 && !e.relatedTarget) go();
        });
        if (p.indexOf('/products/') === 0) {
          window.addEventListener('scroll', function onDeep() {
            var h = document.documentElement.scrollHeight - window.innerHeight;
            if (h > 0 && window.scrollY / h >= 0.6) { window.removeEventListener('scroll', onDeep); go(); }
          }, { passive: true });
        }
      });
    }
    bindReopenLinks();
  }

  function exposeReopen() {
    if (window.ozfOpenPop) return;
    window.ozfOpenPop = function () {
      window.location.href = '/discount/' + CODE + '?redirect=' + encodeURIComponent(PRODUCT_PATH);
    };
  }

  function bindReopenLinks() {
    qa('[data-ozf-reopen]').forEach(function (a) {
      if (a.getAttribute('data-ozf-bound')) return;
      a.setAttribute('data-ozf-bound', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.ozfOpenPop) window.ozfOpenPop();
      });
    });
  }

  /* ==========================================================================
     Cart page
     ========================================================================== */
  function initCart() {
    if (location.pathname.indexOf('/cart') !== 0) return;

    var busy = false;
    function clean() {
      qa('.ozf-cart-rows,.ozf-cart-save,.ozf-cart-eta,.ozf-cart-once,.ozf-cart-up,.ozf-cart-empty,.ozf-cart-second,.ozf-cart-nudge').forEach(function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    }

    function change(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () {
        /* OZ-CART-1002C: re-render the cart and header sections in place (no full
           page reload). Any failure falls back to the old reload. */
        var sec = q('[id^="shopify-section-"][id$="__cart-section"]') ||
                  (q('cart-items-component') && q('cart-items-component').closest('.shopify-section'));
        var head = q('[id^="shopify-section-"][id$="__header_section"]');
        if (!sec) { location.reload(); return; }
        var ids = [sec.id.replace('shopify-section-', '')];
        if (head) ids.push(head.id.replace('shopify-section-', ''));
        return fetch('/cart?sections=' + ids.map(encodeURIComponent).join(','))
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function (data) {
            [sec, head].forEach(function (node) {
              if (!node) return;
              var html = data[node.id.replace('shopify-section-', '')];
              if (!html) throw new Error('no html');
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var fresh = tmp.querySelector('#' + node.id) || tmp.firstElementChild;
              node.innerHTML = fresh.innerHTML;
            });
            document.dispatchEvent(new CustomEvent('cart:update'));
            setTimeout(load, 50);
          });
      }).catch(function () { location.reload(); });
    }

    function render(cart) {
      busy = true;
      setTimeout(function () { busy = false; }, 150);
      clean();

      /* Empty cart: send them back to the frame, not a collection. */
      var empty = qa('main h1, main h2, main p').filter(function (n) {
        return /your cart is empty/i.test(n.textContent);
      })[0];
      if (empty) {
        var link = qa('main a').filter(function (a) { return /continue shopping/i.test(a.textContent); })[0];
        /* OZ-CART-1018: an empty cart leads back to the bed (the product our ads send people to). */
        var BED_PATH = '/products/jumbo-orthopedic-dog-bed';
        if (link) { link.setAttribute('href', BED_PATH); link.textContent = 'See the XL Orthopedic Bed'; }
        if (!/best sleep/.test(empty.textContent)) empty.textContent = 'Your cart is empty \u2014 their best sleep is one tap away.';
        if (!q('.ozf-cart-empty')) {
          var card = el('a', 'ozf-cart-empty',
            '<img src="' + (window.OZ_BED_IMAGE || '') + '" alt="Senior dog sleeping on the XL orthopedic dog bed" width="120" height="120" />' +
            '<span><b>XL Orthopedic Dog Bed</b>' +
            '<em>For senior &amp; large dogs &middot; Free US shipping</em>' +
            '<i>1-year warranty &middot; 30-day money-back guarantee</i></span>');
          card.href = BED_PATH;
          empty.parentNode.insertBefore(card, empty.nextSibling);
        }
        return;
      }
      if (!cart || !cart.item_count) return;

      var totals = q('.cart-totals__container') || q('.cart-totals');
      var qty = cart.items && cart.items[0] ? cart.items[0].quantity : cart.item_count;
      var code = (cart.discount_codes || []).filter(function (d) { return d.applicable; })[0];

      if (totals) {
        if (cart.total_discount > 0 && !q('.ozf-cart-save')) {
          /* A code sits on the line, a bundle sits on the cart. The theme only
             prints Subtotal / discount rows for the cart-level case, so for a
             line-level code we print the same rows ourselves rather than a
             separate green pill. Same information, one presentation. */
          var cartLevel = (cart.cart_level_discount_applications || []).length > 0;
          var host = q('.cart-totals__original-container');
          if (!cartLevel && host && !q('.ozf-cart-rows')) {
            /* items_subtotal_price is already net of line-level discounts, so the
               subtotal we show has to add the discount back to reach full price. */
            var gross = cart.items_subtotal_price + cart.total_discount;
            var pct = Math.round(cart.total_discount / gross * 100);
            var label = code ? code.code + ' · ' + pct + '% off' : pct + '% off';
            host.appendChild(el('div', 'ozf-cart-rows',
              '<span class="cart-totals__item cart-totals__original">' +
                '<span class="cart-totals__original-label">Subtotal</span>' +
                '<span class="cart-totals__original-value cart-secondary-typography">' + money(gross) + '</span>' +
              '</span>' +
              '<ul class="cart-discounts" role="list"><li class="cart-discounts__item">' +
                '<span class="cart-discounts__label">' + label + '</span>' +
                '<span class="cart-discounts__value cart-secondary-typography">&minus;' + money(cart.total_discount) + '</span>' +
              '</li></ul>'));
          }
          /* OZ-CART-1002C: one line. A pack (cart-level discount) also says no code is needed. */
          totals.appendChild(el('div', 'ozf-cart-save', 'You save <b>' + money(cart.total_discount) + '</b>' +
            ((cart.cart_level_discount_applications || []).length ? ' \u2014 no code needed' : ' on this order')));
        }
        /* These belong after the button, not between the total and it. */
        var summary = q('.cart-summary__inner') || totals;

        if (false && !q('.ozf-cart-eta')) { /* OZ-CART-1018: replaced by the dates in cart-summary */
          /* OZ-CART-1002B: above the button, with the shipping promise in the same line. */
          var ea = fmtDate(addBusinessDays(4)), eb = fmtDate(addBusinessDays(9));
          var eRange = ea.split(' ')[0] === eb.split(' ')[0] ? ea + '\u2013' + eb.split(' ').slice(1).join(' ') : ea + ' \u2013 ' + eb;
          summary.appendChild(el('div', 'ozf-cart-eta', TRUCK_SVG + '<span>Arrives <b>' + eRange + '</b> &middot; free tracked shipping</span>'));
        }
      }

      var items = q('cart-items-component') || q('[data-ozf-cart-items]');

      /* The full card sits below the button, where few people scroll. This one
         line sits right under the item, before the totals, and quotes the same
         marginal cost. */
      /* DG: the frame's multi-pack nudge is off on the dog store. */
      if (false && items && cart.item_count < 3 && !q('.ozf-cart-nudge')) {
        var nQty = cart.item_count === 1 ? 2 : 3;
        var nTotal = nQty === 2
          ? Math.round(UNIT_CENTS * 2 * 0.8)
          : Math.round(UNIT_CENTS * 3 * 0.7);
        /* What the bundle takes off full price. 458.00 and 687.00 are what the
           same frames cost one by one, so the saving is a difference the
           customer can check, not a claim. */
        var nFull = UNIT_CENTS * nQty;
        var nSave = nFull - nTotal;
        /* One line that says the same thing as the card further down: the second
           frame is the one you give away. */
        var nLabel = nQty === 2
          ? 'One for you, one to give — take two and save <b>' + money(nSave) + '</b>'
          : 'One more for someone else in the family — take three and save <b>' + money(nSave) + '</b>';
        var nudge = el('button', 'ozf ozf-cart-nudge', nLabel + '. <span class="ozf-cart-nudge__a">Add it</span>');
        nudge.type = 'button';
        nudge.addEventListener('click', function () {
          this.disabled = true;
          this.textContent = 'Adding…';
          change(1, nQty);
        });
        var wrap = q('.cart-items__wrapper') || items;
        wrap.appendChild(nudge);
      }

      /* The incentive and the three arguments live in .cart-page__more-blocks,
         which sits after the summary in the DOM. On a phone that puts the
         button before them; on a desktop the grid pulls the container back
         under the item list. */
      function park() {
        var more = q('.cart-page__more-blocks');
        if (!more) return;
        qa('.ozf-cart-second, .ozf-cart-why').forEach(function (n) {
          if (n.parentNode !== more) more.appendChild(n);
        });
      }

      /* OZ-CART-1002: the second / third frame cards were removed: the one-line
         offer under the item says the same thing without a second block. */

      park();
    }

    /* On a phone the checkout button sits well below the fold once the gift card
       and the summary are in place. This keeps it one tap away. Same scroll +
       poll pair as the product page, because scroll events are not delivered
       everywhere. */
    function initCartSticky(cart) {
      if (!cart || !cart.item_count) return;
      var anchor = qa('button').filter(function (b) {
        return /check\s?out/i.test(b.textContent || '') && !b.closest('.ozf-cbar');
      })[0];
      if (!anchor) return;
      var bar = q('.ozf-cbar');
      if (!bar) {
        bar = el('div', 'ozf ozf-cbar',
          '<span class="ozf-cbar__t"><span class="ozf-cbar__n"></span><span class="ozf-cbar__p"></span></span>' +
          '<button type="button" class="ozf-btn">CHECK OUT</button>');
        q('button', bar).addEventListener('click', function () { location.href = '/checkout'; });
        document.body.appendChild(bar);
      }
      q('.ozf-cbar__n', bar).textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      q('.ozf-cbar__p', bar).textContent = money(cart.total_price);

      if (bar.getAttribute('data-ozf-bound')) return;
      bar.setAttribute('data-ozf-bound', '1');
      /* Show it whenever the real button is not fully on screen. On a 390x844
         phone the button lands at 818-874: visible, but cut in half, and the
         browser chrome eats another 100 px. Half a button is not a button. */
      function sync() {
        var a = anchor.getBoundingClientRect();
        bar.classList.toggle('is-on', a.bottom > window.innerHeight || a.bottom < 0);
      }
      document.addEventListener('scroll', sync, { passive: true, capture: true });
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      setInterval(sync, 300);
    }

    function load() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); initCartSticky(cart); })
        .catch(function () { render(null); });
    }

    onReady(load);
    setTimeout(load, 1500);

    /* The theme re-renders the cart over AJAX; re-apply after each change. */
    var t;
    function again() { clearTimeout(t); t = setTimeout(load, 350); }
    document.addEventListener('cart:update', again);
    document.addEventListener('cart:change', again);
    new MutationObserver(function () { if (!busy) again(); })
      .observe(q('main') || document.body, { childList: true, subtree: true });
  }

  /* Shopify reserves five rows for express wallets even when two render. */
  function fitWallets() {
    var sac = q('shopify-accelerated-checkout-cart');
    if (!sac) return;
    var btns = Array.prototype.slice.call(sac.children).filter(function (c) {
      return getComputedStyle(c).display !== 'none' && c.getBoundingClientRect().height > 0;
    });
    if (!btns.length) return;
    var top = sac.getBoundingClientRect().top;
    var last = btns[btns.length - 1].getBoundingClientRect().bottom;
    var h = Math.ceil(last - top);
    if (h < 40) return;
    sac.style.setProperty('display', 'block', 'important');
    sac.style.setProperty('overflow', 'hidden', 'important');
    sac.style.setProperty('max-height', h + 'px', 'important');
  }

  /* ==========================================================================
     Boot
     ========================================================================== */
  /* Tapping the 1 / 10 counter opens the current image full screen. */
  function initZoom() {
    var btn = q('[data-ozf-zoom]');
    if (!btn || btn.getAttribute('data-ozf-bound')) return;
    btn.setAttribute('data-ozf-bound', '1');
    btn.addEventListener('click', function () {
      var slides = q('[data-ozf-slides]');
      if (!slides) return;
      var w = slides.clientWidth || 1;
      var i = Math.max(0, Math.min(slides.children.length - 1, Math.round(slides.scrollLeft / w)));
      var img = slides.children[i] && slides.children[i].querySelector('img');
      if (!img) return;
      var ov = el('div', 'ozf ozf-zoom');
      ov.innerHTML = '<button type="button" class="ozf-zoom__x" aria-label="Close">&times;</button>' +
                     '<img src="' + (img.currentSrc || img.src) + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '">';
      function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.body.style.overflow = ''; }
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.className === 'ozf-zoom__x') close(); });
      document.addEventListener('keydown', function esc(e) {
        if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
      });
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { ov.classList.add('on'); });
    });
  }

  function boot() {
    initGallery();
    initZoom();
    initBuyBox();
    initSticky();
    initFaq();
    bindReopenLinks();

    /* Delivery estimate anywhere it is asked for outside the buy box. */
    qa('[data-ozf-eta-inline]').forEach(function (n) {
      var t = etaText();
      if (n.textContent !== t) n.textContent = t;
    });

    /* DG (dog store): the frame's seasonal line, $199 promo and FRAME15 welcome pop-up are off. */
  }

  onReady(function () {
    boot();
    initCart();
    var n = 0;
    (function loop() { fitWallets(); if (n++ < 20) setTimeout(loop, 500); })();
    window.addEventListener('resize', fitWallets);

    /* The theme re-renders over AJAX, so re-run boot() afterwards. The observer
       must never react to boot()'s own writes: it is disconnected while boot()
       runs, and every run is debounced. Without this it loops forever. */
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        mo.disconnect();
        try { boot(); fitWallets(); } catch (e) {}
        mo.observe(document.body, { childList: true, subtree: true });
      }, 250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();

/* OZ: native product form submit -> AJAX /cart/add.js so Shopify pixels emit
   product_added_to_cart (Meta/Google/TikTok/Klaviyo AddToCart). Falls back to a normal submit on error. */
(function () {
  if (window.__ozAtc) return; window.__ozAtc = true;
  /* OZ-FAST-1004: the cart's item count, read once on the product page, so a tap can
     skip /cart/clear.js when the cart is already empty (one round trip less).
     null = unknown, and then the cart is always cleared first. */
  var cartCount = null;
  function readCart() {
    if (!window.fetch || !document.getElementById('ozf-product-form')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCount = c.item_count; })
      .catch(function () { cartCount = null; });
  }
  readCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) { cartCount = null; readCart(); } });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    /* Only our own product-page form. The theme's quick-add cards already post
       to /cart/add.js themselves; intercepting them too added the item twice. */
    /* OZ-CART-1002: the form holds <input name="id">, which shadows form.id. */
    if (f.getAttribute('id') !== 'ozf-product-form') return;
    var a = f.getAttribute('action') || '';
    if (a.indexOf('/cart/add') < 0) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    /* OZ-TIER-1002: one product, packs priced by quantity: empty the cart first so the
       cart holds exactly the pack chosen (tapping twice never doubles it). */
    var fd = new FormData(f);
    var cleared = cartCount === 0 ? Promise.resolve()
      : fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
    cleared
      .then(function () { return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { if (!r.ok) throw r; cartCount = null; window.location.assign('/cart'); })
      .catch(function () { if (btn) btn.disabled = false; HTMLFormElement.prototype.submit.call(f); });
  }, true);
})();


/* OZ-1002B-CART: cart page.
   1) The gift-note accordion goes under the checkout button, so the button
      sits right under the total.
   2) Mobile: a sticky "Check out" bar with the total whenever the real
      checkout button is off screen. It clicks the real button. */
(function () {
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  function q(s, r) { return (r || document).querySelector(s); }

  function placeNote() {
    var ctas = q('.cart__ctas');
    var note = q('.cart-totals .cart-actions');
    if (ctas && note) ctas.parentNode.insertBefore(note, ctas.nextSibling);
  }

  var bar = null;
  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'ozf-cartbar';
    bar.innerHTML = '<span class="ozf-cartbar__t"><span class="ozf-cartbar__l">Total</span>' +
      '<b class="ozf-cartbar__p"></b></span>' +
      '<button type="button" class="ozf-cartbar__b"><svg class=\"oz-lock\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><rect x=\"5\" y=\"11\" width=\"14\" height=\"10\" rx=\"2\"/><path d=\"M8 11V8a4 4 0 0 1 8 0v3\" stroke-linecap=\"round\"/></svg> SECURE CHECKOUT</button>'; /* OZ-CART-1002B */
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () {
      var real = realBtn();
      if (real) real.click();
    });
    return bar;
  }
  function realBtn() {
    var list = document.querySelectorAll('.cart__checkout-button, button[name="checkout"], input[name="checkout"]');
    return list.length ? list[0] : null;
  }
  function sync() {
    var real = realBtn();
    if (!real) { if (bar) bar.classList.remove('is-on'); return; }
    buildBar();
    var totalEl = q('.cart-totals__total-value');
    var p = bar.querySelector('.ozf-cartbar__p');
    if (totalEl && p) p.textContent = totalEl.textContent.replace(/\s+/g, ' ').trim().replace(/\s*USD$/, '').replace(/\.00$/, '');
    var r = real.getBoundingClientRect();
    var visible = r.top < window.innerHeight - 70 && r.bottom > 0;
    bar.classList.toggle('is-on', !visible && window.innerWidth < 750);
  }
  function run() { placeNote(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  setInterval(run, 600);
})();


/* OZ-TIDIO-1002: on a phone, while the sticky buy bar (product page) or the
   checkout bar (cart) is showing and the chat is closed, lift the Tidio bubble
   just above the bar so it never covers the buy button. */
(function () {
  var open = false;
  function bar() {
    if (window.innerWidth >= 750) return null;
    return document.querySelector('.ozf-sticky.is-on .ozf-sticky__card, .ozf-cartbar.is-on, .dg-sticky.is-visible');
  }
  function sync() {
    var host = document.getElementById('tidio-chat');
    if (!host) return;
    var b = bar();
    if (b && !open) {
      var lift = Math.max(0, Math.round(window.innerHeight - b.getBoundingClientRect().top + 6));
      host.style.setProperty('bottom', lift + 'px', 'important');
    } else {
      host.style.removeProperty('bottom');
    }
  }
  document.addEventListener('tidioChat-open', function () { open = true; sync(); });
  document.addEventListener('tidioChat-close', function () { open = false; sync(); });
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  setInterval(sync, 400);
})();
